/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useRef, useState, useEffect } from 'react'
import Avatar from '../../Assets/Images/avatar-default.svg'
import Select, { createFilter } from 'react-select'
import makeAnimated from 'react-select/animated'
import { useController } from 'react-hook-form'
import { debounce } from 'lodash'
import CropperImage from './CropperImage'
import withReactContent from 'sweetalert2-react-content'
import Swal from 'sweetalert2'
import { fileValidator } from '../Helpers/GenericFunctions'
import { toastSweetAlert } from '../Helpers/ToastSweetAlert'
import { UPDATE_AVATAR } from '../../graphql/Global/uploadFiles'
import { useMutation } from '@apollo/client'
import { GET_USER_BY_ID } from '../../graphql/Catalog/Users/user'
import AsyncSelect from 'react-select/async'
import DragDropComponent from '../../helpers/DragDropComponent'

export const InputController = ({
  choosenOptions = false,
  valueManual,
  label = null,
  name,
  placeholderTxt = '',
  control,
  rows = 3,
  options = '',
  inputType = 'text',
  userId = null,
  isMulti = false,
  closeOnSelect = true,
  validateFormat = 'image',
  validateFormatMsg = 'Elija uno de los formatos sugeridos',
  formatAccept = 'image/*',
  previewPic = Avatar,
  addClass = '',
  readOnly = false,
  disabled = false,
  changeAction = () => {},
  blurAction = () => {},
  textAreaNotResize = false,
  loadOptionsAsyncSelect = () => {},
  menuPosition = 'auto',
  onInputChange = () => {},
  infoText = false,
  //Properties for drag and drop
  maxFiles = 1,
  allowedFileTypes = ['png', 'jpeg', 'jpg', 'pdf'],
  newDropAttachment = false,
  editDropAttachment = false,
  setFilesEdit = false,
  // ratingLength = 5,
  ...props
}) => {
  //DRAG AND DROP FILES
  const [files, setFiles] = useState([])
  //RATING STATE
  // const [selectedRating, setSelectedRating] = useState(0)

  const [cropper, setCropper] = useState(null)
  const [image, setImage] = useState(Avatar)
  const [result, setResult] = useState(false)
  const [updateAvatar] = useMutation(UPDATE_AVATAR, {
    refetchQueries: [
      GET_USER_BY_ID,
      {
        variables: {
          getUserByIdId: parseInt(userId),
        },
      },
    ],
  })
  const MySwal = withReactContent(Swal)
  const {
    field: { onChange, value },
    fieldState: { invalid, error },
  } = useController({ control, name, defaultValue: '' })

  const animatedComponents = makeAnimated()

  const filterConfigSelect = {
    ignoreCase: true,
    ignoreAccents: true,
    trim: true,
    matchFrom: 'any',
  }

  const handleChange = (e) => {
    onChange(e.target.value)
    doAction(e)
  }

  const handleChangeChoosen = (e) => {
    if (isMulti) onChange(e)
    else onChange(e?.value)
    doAction(e)
  }

  const handleChangeAsyncSelect = (e) => {
    onChange(e)
    doAction(e)
  }

  // const handleChangeRating = (e) => {
  //   setSelectedRating(+e.target.value)
  //   onChange(+e.target.value)
  //   doAction(e)
  // }

  const doAction = useRef(
    debounce((e) => {
      changeAction(e)
    }, 500)
  ).current

  const handleClickInput = (name) => {
    const element = document.getElementById(name)
    element.click()
  }

  const handleChangeImage = async (e, validateFormat, autoUpdate = false) => {
    if (!e.target.files[0]) {
      return
    }
    const validate = await fileValidator(e.target.files[0], validateFormat)
    if (validate) {
      changeAction(e)
      const isComplete = await handleCropImage(e.target.files[0])
      if (isComplete) {
        setTimeout(async function () {
          let res, img

          img = localStorage.getItem('usersImage')
          if (img) res = await getFileFromUrl(img, '.jpg')
          else res = e.target.files[0]

          onChange(res)
          if (autoUpdate) {
            await updateAvatar({
              variables: {
                idUser: parseInt(userId),
                avatarFile: res,
              },
            })
          }
        }, 350)
      }
    } else
      return toastSweetAlert({
        mode: 'error',
        message: validateFormatMsg,
      })
  }

  const handleChangeFile = async (e, validateFormat) => {
    const file = e.target.files[0]
    if (!file) return
    const validate = await fileValidator(e.target.files[0], validateFormat)
    if (validate) {
      changeAction(e)
      onChange(e)
    } else {
      onChange('')
      return toastSweetAlert({
        mode: 'error',
        message: validateFormatMsg,
      })
    }
  }

  const handleCheck = (e) => {
    onChange(e.target.checked)
  }

  const handleCropImage = async (file) => {
    if (file) {
      return new Promise((resolve) => {
        const reader = new FileReader()
        reader.onload = async () => {
          await MySwal.fire({
            title: 'Selecciona la fracción que deseas utilizar',
            allowOutsideClick: false,
            html: (
              <CropperImage _image={reader.result} setCropper={setCropper} />
            ),
            showDenyButton: true,
            focusConfirm: false,
            denyButtonText: '<i class="fas fa-times"> Cancelar</i>',
            confirmButtonText: '<i class="fas fa-check"> Finalizar</i>',
            customClass: {
              confirmButton: 'btn btn-sm btn-migrates',
              denyButton: 'btn btn-sm btn-danger',
              icon: 'no-border',
            },
          }).then((result) => {
            setResult(result.isConfirmed)
            return resolve(result.isConfirmed)
          })
        }
        reader.readAsDataURL(file)
      })
    }
  }

  const getFileFromUrl = async (url, defaultType) => {
    const response = await fetch(url)
    const data = await response.blob()
    return new File([data], 'file', {
      type: response.headers.get('content-type') || defaultType,
    })
  }

  //CONTROl THE SET OF THE CROPPED IMAGE
  useEffect(() => {
    if (result) {
      localStorage.setItem('usersImage', cropper?.toDataURL())
      setImage(cropper?.toDataURL())
      setResult(false)
    }
  }, [result, cropper, image])

  //SETIMAGE PREVIEW WHEN EXISTS
  useEffect(() => {
    if (!cropper) {
      setImage(previewPic)
    }
  }, [image, previewPic, cropper])

  useEffect(() => {
    if (editDropAttachment) {
      setFiles(editDropAttachment)
    }
  }, [editDropAttachment])

  return (
    <>
      {inputType === 'number' && (
        <>
          {label && (
            <label>
              <b>{label}</b>
            </label>
          )}
          <input
            {...props}
            onChange={(e) => handleChange(e)}
            type="number"
            value={valueManual ? valueManual : value ? value : ''}
            onBlur={blurAction}
            onInput={(e) => {
              const val = e.target.value
              const max = e.target.maxLength
              if (max > 0 && val.length > max)
                e.target.value = val.slice(0, max)
            }}
            className={`form-control rounded-2 ${
              invalid && 'is-invalid'
            } ${addClass}`}
            readOnly={readOnly}
            disabled={disabled}
            placeholder={
              placeholderTxt !== '' ? placeholderTxt : props?.placeholder
            }
          />
          <span className="error invalid-feedback">{error?.message}</span>
        </>
      )}

      {inputType === 'text' && (
        <>
          {label && (
            <label>
              <b>{label}</b>
            </label>
          )}
          <input
            {...props}
            onChange={(e) => handleChange(e)}
            value={valueManual ? valueManual : value ? value : ''}
            onBlur={blurAction}
            className={`form-control rounded-2 ${
              invalid && 'is-invalid'
            } ${addClass}`}
            readOnly={readOnly}
            disabled={disabled}
            placeholder={
              placeholderTxt !== '' ? placeholderTxt : props?.placeholder
            }
          />
          <span className="error invalid-feedback">{error?.message}</span>
        </>
      )}

      {inputType === 'range' && (
        <>
          {label && (
            <label>
              <b>{label}</b>
            </label>
          )}
          <input
            {...props}
            type="range"
            onChange={(e) => handleChange(e)}
            value={valueManual ? valueManual : value ? value : ''}
            onBlur={blurAction}
            className={`form-range-custom form-control rounded-2 ${
              invalid && 'is-invalid'
            } ${addClass}`}
            readOnly={readOnly}
            disabled={disabled}
            placeholder={
              placeholderTxt !== '' ? placeholderTxt : props?.placeholder
            }
          />
          <span className="error invalid-feedback">{error?.message}</span>
        </>
      )}

      {inputType === 'textarea' && (
        <>
          {label && (
            <label>
              <b>{label}</b>
            </label>
          )}
          <textarea
            {...props}
            onChange={(e) => handleChange(e)}
            value={value ? value : ''}
            rows={rows}
            onBlur={blurAction}
            className={`form-control ${
              textAreaNotResize ? '' : 'textarea_not_resize'
            } rounded-2 ${invalid && 'is-invalid'} ${addClass}`}
            readOnly={readOnly}
            disabled={disabled}
            placeholder={
              placeholderTxt !== '' ? placeholderTxt : props?.placeholder
            }
          />
          <span className="error invalid-feedback">{error?.message}</span>
        </>
      )}

      {inputType === 'select' && (
        <>
          {label && (
            <label>
              <b>{label}</b>
            </label>
          )}
          <select
            {...props}
            onChange={(e) => handleChange(e)}
            value={value ? value : ''}
            rows={rows}
            onBlur={blurAction}
            className={`form-control rounded-2 ${
              invalid && 'is-invalid'
            } ${addClass}`}
            readOnly={readOnly}
            disabled={disabled}
            placeholder={
              placeholderTxt !== '' ? placeholderTxt : props?.placeholder
            }
          >
            <option disabled hidden value="">
              Seleccione una opción
            </option>
            <>
              {options.length > 0 ? (
                <> {options}</>
              ) : (
                <option value="" disabled>
                  No hay datos registrados
                </option>
              )}
            </>
          </select>
          <span className="error invalid-feedback">{error?.message}</span>
        </>
      )}

      {inputType === 'choosen' && !choosenOptions && (
        <>
          {/* withFilter */}
          {label && (
            <label>
              <b>{label}</b>
            </label>
          )}
          <Select
            {...props}
            closeMenuOnSelect={closeOnSelect}
            components={animatedComponents}
            name={name}
            placeholder={
              placeholderTxt !== '' ? placeholderTxt : props?.placeholder
            }
            NoOptionsMessage="Sin resultados"
            isMulti={isMulti}
            control={control}
            options={options}
            onBlur={blurAction}
            onChange={(e) => handleChangeChoosen(e)}
            className={`${invalid && 'is-invalid'} ${addClass}`}
            value={
              valueManual !== ''
                ? isMulti
                  ? value
                  : options?.find((option) => {
                      if (
                        parseInt(option.value) === parseInt(value) ||
                        option.value === value
                      ) {
                        return option
                      }
                      return null
                    })
                : null
            }
            styles={{
              control: (base) => ({
                ...base,
                borderColor: invalid ? '#dc3545' : '#ced4da',
                ':hover': { borderColor: invalid ? '#dc3545' : '#ced4da' },
              }),
            }}
            readOnly={readOnly}
            isDisabled={disabled}
            menuPosition={menuPosition}
            onInputChange={onInputChange}
            filterOption={createFilter(filterConfigSelect)}
          />
          <span className="error invalid-feedback">{error?.message}</span>
          {/* <small className="text-muted">
            Solo aparecerán los choferes disponibles.
          </small> */}
        </>
      )}

      {inputType === 'choosen' && choosenOptions && (
        <>
          {label && (
            <label>
              <b>{label}</b>
            </label>
          )}
          <Select
            {...props}
            closeMenuOnSelect={closeOnSelect}
            components={animatedComponents}
            name={name}
            placeholder={
              placeholderTxt !== '' ? placeholderTxt : props?.placeholder
            }
            NoOptionsMessage="Sin resultados"
            isMulti={isMulti}
            control={control}
            options={options}
            onBlur={blurAction}
            onChange={(e) => handleChangeChoosen(e)}
            className={`${invalid && 'is-invalid'} ${addClass}`}
            value={
              valueManual !== ''
                ? isMulti
                  ? choosenOptions && props?.value && props?.value.length > 0
                    ? [...props.value]
                    : value
                  : options?.reduce((acc, option) => {
                      if (choosenOptions && option.options) {
                        const foundOption = option.options.find(
                          (opt) =>
                            parseInt(opt.value) === parseInt(value) ||
                            opt.value === value
                        )
                        if (foundOption) {
                          acc = foundOption
                        }
                      } else if (
                        parseInt(option.value) === parseInt(value) ||
                        option.value === value
                      ) {
                        acc = option
                      }
                      return acc
                    }, null)
                : null
            }
            styles={{
              control: (base) => ({
                ...base,
                borderColor: invalid ? '#dc3545' : '#ced4da',
                ':hover': { borderColor: invalid ? '#dc3545' : '#ced4da' },
              }),
            }}
            readOnly={readOnly}
            isDisabled={disabled}
            menuPosition={menuPosition}
          />
          <span className="error invalid-feedback">{error?.message}</span>
        </>
      )}

      {inputType === 'asyncSelect' && (
        <>
          {label && (
            <label>
              <b>{label}</b>
            </label>
          )}
          <AsyncSelect
            {...props}
            name={name}
            placeholder={
              placeholderTxt !== '' ? placeholderTxt : props?.placeholder
            }
            noOptionsMessage={() => 'Sin resultado'}
            control={control}
            onChange={(e) => handleChangeAsyncSelect(e)}
            loadOptions={(search, callback) =>
              loadOptionsAsyncSelect(search, callback)
            }
            className={`${invalid && 'is-invalid'} ${addClass}`}
            value={valueManual ? valueManual : value ? value : ''}
            styles={{
              control: (base) => ({
                ...base,
                borderColor: invalid ? '#dc3545' : '#ced4da',
                ':hover': { borderColor: invalid ? '#dc3545' : '#ced4da' },
              }),
            }}
          />
          <span className="error invalid-feedback">{error?.message}</span>
        </>
      )}

      {inputType === 'image' && (
        <div className="container-upload">
          <div className="avatar-upload">
            <input
              {...props}
              id={name}
              type="file"
              hidden
              defaultValue={value}
              onChange={(e) => handleChangeImage(e, validateFormat)}
              onBlur={blurAction}
              accept={formatAccept}
              control={control}
              readOnly={readOnly}
              disabled={disabled}
            />
            <label
              className="btn btn-danger circle-btn"
              htmlFor="imageUpload"
              onClick={() => handleClickInput(name)}
            >
              <i
                className={`fas fa-${
                  cropper || image ? 'pencil-alt' : 'plus'
                } `}
              ></i>
            </label>
          </div>
          <div className="avatar-preview">
            <img src={cropper || image ? image : Avatar} alt="avatar-upload" />
          </div>
          <span className="error">{error?.message}</span>
        </div>
      )}

      {inputType === 'imageAutoSend' && (
        <div className="container-upload">
          <div className="avatar-upload">
            <input
              {...props}
              id={name}
              type="file"
              hidden
              defaultValue={value}
              onChange={(e) => handleChangeImage(e, validateFormat, true)}
              onBlur={blurAction}
              accept={formatAccept}
              control={control}
              readOnly={readOnly}
              disabled={disabled}
            />
            <label
              className="btn btn-danger circle-btn"
              htmlFor="imageUpload"
              onClick={() => handleClickInput(name)}
            >
              <i
                className={`fas fa-${
                  cropper || image ? 'pencil-alt' : 'plus'
                } `}
              ></i>
            </label>
          </div>
          <div className="avatar-preview">
            <img src={cropper || image ? image : Avatar} alt="avatar-upload" />
          </div>
          <span className="error">{error?.message}</span>
        </div>
      )}

      {inputType === 'file' && (
        <>
          {label && (
            <label>
              <b>{label}</b>
            </label>
          )}
          <input
            {...props}
            type="file"
            defaultValue={value}
            onChange={(e) => handleChangeFile(e, validateFormat)}
            accept={formatAccept}
            onBlur={blurAction}
            className={`form-control rounded-2 ${
              invalid && 'is-invalid'
            } ${addClass}`}
            readOnly={readOnly}
            disabled={disabled}
          />
          <span className="error invalid-feedback">{error?.message}</span>
        </>
      )}
      {inputType === 'checkbox' && (
        <>
          {label && (
            <label>
              <b>{label}</b>
            </label>
          )}
          <input
            {...props}
            type="checkbox"
            checked={value}
            onChange={(e) => handleCheck(e)}
            onBlur={blurAction}
            control={control}
            className={`form-control rounded-2 ${
              invalid && 'is-invalid'
            } ${addClass}`}
            readOnly={readOnly}
            disabled={disabled}
          />
          <span className="error invalid-feedback">{error?.message}</span>
        </>
      )}
      {inputType === 'attachment' && (
        <>
          {label && (
            <label>
              <b>{label}</b>
            </label>
          )}
          <DragDropComponent
            id={name}
            onChange={onChange}
            changeAction={changeAction}
            files={files}
            setFiles={setFiles}
            invalid={invalid}
            addClass={addClass}
            readOnly={readOnly}
            disabled={disabled}
            allowedFileTypes={allowedFileTypes}
            maxFiles={maxFiles}
            error={error}
            newDropAttachment={newDropAttachment}
            editMode={editDropAttachment}
            setFilesEdit={setFilesEdit}
            label={label}
          />

          <span className="error">{error?.message}</span>
        </>
      )}
      {/* {inputType === 'rating' && (
        <>
          {label && (
            <label>
              <b>{label}</b>
            </label>
          )}
          <div className={`rating ${addClass} ${invalid && 'rating-invalid'}`}>
            {[...Array(ratingLength)].map((_, i) => {
              const starValue = ratingLength - i
              return (
                <React.Fragment key={starValue}>
                  <input
                    type="radio"
                    id={`star${starValue}`}
                    name={name}
                    value={starValue}
                    checked={
                      valueManual !== undefined
                        ? valueManual === starValue
                        : value === starValue
                    }
                    onChange={handleChangeRating}
                    className={`form-control rounded-2 ${
                      invalid && 'is-invalid'
                    } ${addClass}`}
                  />
                  <label
                    htmlFor={`star${starValue}`}
                    className={
                      (
                        valueManual !== undefined
                          ? valueManual === starValue
                          : value === starValue
                      )
                        ? 'selected'
                        : ''
                    }
                  ></label>
                </React.Fragment>
              )
            })}
          </div>
          {error && (
            <div className="invalid-feedback" style={{ display: 'block' }}>
              {error.message}
            </div>
          )}
        </>
      )} */}
      {infoText && <small className="text-muted">{infoText}</small>}
    </>
  )
}
export default InputController
